import * as React from "react";
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import * as _ from "lodash";

import Main from "../../shared/layout/Main";
import Content from "../../project/components/content/Content";
import ContentHeader from "../../project/components/content/ContentHeader";
import ContentHeaderTitle from "../../project/components/content/ContentHeaderTitle";
import ContentHeaderControls from "../../project/components/content/ContentHeaderControls";
import ContentBody from "../../project/components/content/ContentBody";
import {Store} from "../../project/reducer";
import {Dispatch} from "../../../../shared/ts/interfaces/dispatch";
import {Button} from "../../shared/button/Button";
import {FormActions} from "../../../../shared/ts/helpers/create_form_actions";
import {closePanel, openPanel, openTab} from "../../context_panel/actions/context_panel";
import {RouterProps, RouterState} from "../../../../shared/ts/interfaces/router";
import {HocModalix, modalix} from "../../../../shared/ts/decorators/modalix";
import {RequestState} from "../../../../shared/ts/helpers/util";
import {ReelForm} from "../components/ReelForm";
import {reelEditPatch} from "../actions/reels/edit";
import {reelFetchDetail} from "../actions/reels/fetch";
import {
    addReelFormActions,
    clearReelAddEditErrors,
    clearReelAddEditViewState
} from "../actions/reels/add";
import {ReelModal} from "../components/ReelModal";
import {IReel, IReelForms, IReelFormValues} from "../reducers/reels";
import {url} from "../../../../shared/ts/helpers/routing";
import ReelDialog from "../components/ReelDialog";
import {getReelsFormValues, ReelFormError} from "../helpers/get_reels_form_values";
import {IReelsCreator} from "../reducers/reelsCreator";
import {addErrorAlert} from "../../shared/alerts/actions";
import {reelCreatorAdd} from "../actions/reels_creator/add";
import {reelCreatorEditPatch} from "../actions/reels_creator/edit";

interface IStateProps {
    reelDetail: IReelForms;
    contextPanelOpened: boolean;
}

interface IActionsProps {
    formActions: FormActions;
    actions: {
        addErrorAlert: typeof addErrorAlert;
        reelCreatorAdd: typeof reelCreatorAdd;
        reelCreatorEditPatch: typeof reelCreatorEditPatch;
        reelEditPatch: typeof reelEditPatch;
        reelFetchDetail: typeof reelFetchDetail;
        clearReelAddEditErrors: typeof clearReelAddEditErrors;
        clearReelAddEditViewState: typeof  clearReelAddEditViewState;
        openPanel: typeof openPanel;
        closePanel: typeof closePanel;
        openTab: typeof openTab;
    };
}

interface IOwnProps extends RouterState, RouterProps {
    hoc: HocModalix;
}

interface IProps extends IStateProps, IActionsProps, IOwnProps {}

interface IState {
    isCancelDialogOpen: boolean;
    initialImage: string | Blob;
}

@modalix(ReelModal)
class ReelEditViewC extends React.Component<IProps, IState> {

    constructor(props: IProps) {
        super(props);
        this.state = {
            isCancelDialogOpen: false,
            initialImage: ""
        };
    }

    public async componentDidMount() {
        const creationId = parseInt(this.props.params["id"], 10);
        const creationDetail: IReel = await this.props.actions.reelFetchDetail(creationId) as any;
        this.triggerPopulatingDataToForm(creationDetail, creationDetail.creator);
    }

    private triggerPopulatingDataToForm = (creation: IReel, reelCreatorDetails: {image?: string}) => {
        const creator = creation.creator ? creation.creator.pk : null;
        const action_button_property = creation.action_button_property ? creation.action_button_property : null;
        const rawFormValues = ReelForm.fromJSON({
            ...creation,
            creator,
            ...(action_button_property ? {action_button_property_enabled: true} : {})
        });
        this.props.formActions.update({
            ...rawFormValues,
            ...(rawFormValues.region ? {region: {value: rawFormValues.region.pk}} : {}),
            ...(_.isFinite(creator) ? {
                creator: {value: creator},
                creator_image: reelCreatorDetails.image ? {
                    ...rawFormValues.creator_image,
                    selected: reelCreatorDetails.image.split("/").pop(),
                    stored: reelCreatorDetails.image
                }: {
                    ...rawFormValues.creator_image
                }
            } : {}),
            ...(creation.display_in_offer ? {
                display_in_offer_enabled: true,
                display_in_offer: {value: creation.display_in_offer}
            } : {}),
        });
    };

    public componentWillUnmount(): void {
        this.props.actions.clearReelAddEditViewState();
    }

    /**
     * Callback
    */
    private openPreviewModal = () => {
        this.props.hoc.modalix.show<any>({
            imageAdCreationFormData: this.props.reelDetail.form,
            onReject: () => this.props.hoc.modalix.hide()
        });
    };

    private onCancelDialogOpen = () => {
        this.setState({isCancelDialogOpen: false});
    };

    private onOkDialogOpen = () => {
        const link = url("app:in:video:reel:list");
        this.props.router.push(link);
    };

    private onCancel = () => {
        this.setState({isCancelDialogOpen: true});
    };

    private onSubmit = async () => {
        try {
            const {reelCreator, reel} = getReelsFormValues(this.props.reelDetail.form);
            const savedCreator = await this.handleCreatorFormSubmit(reelCreator);

            if (savedCreator) {
                this.handleCreatorFieldsUpdate(savedCreator);
                return this.handleFormSubmit({
                    ...reel,
                    creator: savedCreator.pk
                });
            }
        } catch (error) {
            const message = error.name === "ReelFormError" ? error.message : "Wystąpił błąd podczas zapisywania reels";
            this.props.actions.addErrorAlert(message);
        }
    };

    private handleCreatorFieldsUpdate = (creator: IReelsCreator) => {
        this.props.formActions.update({
            creator: {
                label: creator.name,
                value: creator.pk,
                image: creator.image
            }
        });
    };

    private handleCreatorFormSubmit = async (reelCreator: {pk: number; image?: string} | {name: string; image?: string}) => {
        if (!("pk" in reelCreator)) {
            return this.props.actions.reelCreatorAdd({name: reelCreator.name, image: reelCreator.image || ""}) as any;
        }

        if ("pk" in reelCreator && reelCreator.image) {
            return this.props.actions.reelCreatorEditPatch(reelCreator.pk, {image: reelCreator.image}) as any;
        }

        return Promise.resolve(reelCreator);
    }

    private handleFormSubmit = async (creation: Omit<IReelFormValues, "creator_image">) => {
        const reelId = parseInt(this.props.params["id"], 10);

        (this.props.actions.reelEditPatch(reelId, creation as any) as any)
            .then((response: IReel) => {
                if (response != null) {
                    this.props.actions.clearReelAddEditErrors();
                }
            });
    };

    /**
     * Render
     */
    public render() {
        const {request} = this.props.reelDetail;
        return (
            <Main>
                <Content>
                    <ContentHeader>
                        <ContentHeaderTitle>Reklama Reel</ContentHeaderTitle>

                        <ContentHeaderControls>
                            <Button
                                className="ttu ph-xxl mr-xl"
                                type="submit"
                                color="success"
                                size="sm"
                                submitting={request === RequestState.Waiting}
                                onClick={this.onSubmit}
                            >
                                Zapisz kreację
                            </Button>
                            <Button
                                className="ttu ph-xxl mr-xl"
                                type="submit"
                                color="primary-ghost"
                                size="sm"
                                onClick={() => this.openPreviewModal()}
                            >
                                Podgląd kreacji
                            </Button>
                            <Button
                                className="ttu ph-xxxl"
                                type="submit"
                                color="default"
                                size="sm"
                                submitting={request === RequestState.Waiting}
                                onClick={this.onCancel}
                            >
                                Anuluj
                            </Button>
                        </ContentHeaderControls>
                    </ContentHeader>

                    <ContentBody>
                        <ReelForm
                            onSubmit={this.onSubmit}
                            errors={this.props.reelDetail.errors ? this.props.reelDetail.errors.fieldErrors : null}
                            values={this.props.reelDetail.form}
                            updateFormAction={this.props.formActions.update}
                            handlePreview={() => this.openPreviewModal()}
                            handleCancel={this.onCancel}
                        />
                        <ReelDialog
                            message="Czy na pewno chcesz porzucić wprowadzane zmiany?"
                            handleClose={this.onCancelDialogOpen}
                            onCancel={this.onCancelDialogOpen}
                            onOk={this.onOkDialogOpen}
                            isModalOpen={this.state.isCancelDialogOpen}
                        />
                    </ContentBody>
                </Content>
            </Main>
        );
    }
}

export const ReelEditView = connect(mapStateToProps, mapActionsToProps)(ReelEditViewC);

/**
 * Connect
 */

function mapStateToProps(store: Store): IStateProps {
    return {
        reelDetail: store.video.reel.detail,
        contextPanelOpened: store.video.reel.list.contextPanel.opened
    };
}

function mapActionsToProps(dispatch: Dispatch): IActionsProps {
    return {
        formActions: bindActionCreators(addReelFormActions, dispatch),
        actions: bindActionCreators({
            addErrorAlert,
            reelCreatorAdd,
            reelCreatorEditPatch,
            reelEditPatch,
            reelFetchDetail,
            openPanel,
            closePanel,
            openTab,
            clearReelAddEditViewState,
            clearReelAddEditErrors,
        }, dispatch)
    };
}
